export default "__VITE_ASSET__Dju8Yai7__$_?component__"